// extracted by mini-css-extract-plugin
module.exports = {"phoneArea":"style_phoneArea__fH23X","phoneNumber":"style_phoneNumber__bzWVP"};